// reducers/lessonUpdateReducer.js
import { UPDATE_ZOOM_LINK } from "../Actions/lessonActions";

const initialState = {
  updatedLessonId: null,
  zoomLink: "",
  success: false,
  error: null,
};

const lessonUpdateReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ZOOM_LINK:
      return {
        ...state,
        updatedLessonId: action.payload.lessonId,
        zoomLink: action.payload.zoomLink,
        success: true,
        error: null,
      };

    default:
      return state;
  }
};

export default lessonUpdateReducer;
